<template>
  <div id="WellCompany">
    <ul class="wellcompany-wrap">
      <li
        class="wellcompany-item"
        v-for="(item, index) in wellCompanyData"
        :key="index"
        @click="goCompany(item.clientId)"
      >
        <div class="wellcompany-inner">
          <div class="wellcompany-logo-box">
            <img :src="item.logo" class="wellcompany-logo" alt="" />
          </div>
          <h5 class="wellcompany-tit">{{ item.clientName }}</h5>
          <p class="wellcompany-desc">
            {{ item.industryStr }} | {{ item.companyScaleIdStr }}
          </p>
          <p class="wellcompany-num-wrap">
            共有
            <span class="wellcompany-num">{{ item.jobCount }}</span> 个在招职位
          </p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "WellCompany",
  props: ["wellCompanyData"],
  data() {
    return {};
  },
  created() {},
  methods: {
    goCompany(id) {
      this.$router.push({ path: "/company", query: { id } });
    },
  },
};
</script>
<style scoped>
.wellcompany-wrap {
  display: flex;
  flex-wrap: wrap;
  margin-right: -20px;
}
.wellcompany-item {
  padding: 0 20px 20px 0;
  width: 25%;
  cursor: pointer;
}
.wellcompany-inner {
  padding: 28px;
  background: #ffffff;
  text-align: center;
}
.wellcompany-inner:hover {
  box-shadow: 0px 0px 15px 0px rgba(205, 205, 205, 0.5);
}
.wellcompany-logo-box {
  width: 60px;
  height: 60px;
  border-radius: 4px;
  border: 1px solid #f5f5f5;
  margin: 0 auto;
}
.wellcompany-logo {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.wellcompany-tit {
  font-size: 16px;
  color: #333333;
  margin: 14px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.wellcompany-inner:hover .wellcompany-tit {
  color: #3b87ff;
}
.wellcompany-desc {
  color: #666;
  font-size: 12px;
}
.wellcompany-num-wrap {
  width: 170px;
  height: 34px;
  line-height: 34px;
  text-align: center;
  font-size: 12px;
  color: #333;
  border-radius: 2px;
  border: 1px solid #dddddd;
  margin: 0 auto;
  margin-top: 20px;
}
.wellcompany-inner:hover .wellcompany-num-wrap {
  border: 1px solid #3b87ff;
}
.wellcompany-num {
  color: #3b87ff;
}
</style>
